'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createPayment;
function createPayment() {
    var fixture = {};

    return {
        setAmount: function setAmount(amount) {
            fixture.amount = amount;
            return this;
        },
        setCash: function setCash() {
            fixture.type = 'cash';
            return this;
        },
        setCreditCard: function setCreditCard(card) {
            fixture.type = 'credit';
            fixture.card = card;
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/Payment.js
// module id = 719
// module chunks = 0